const generateUnLayerable = () => ({
  model: {
    defaults: {
      layerable: false,
    },
  },
})

export default generateUnLayerable
